import React from 'react';
import {
    List,
    Typography, 
    Space,
    Image,
} from 'antd';
import './LZHXOrderDetailPage.css';
import axios from 'axios';
import qs from 'qs';

const { Title } = Typography;

const orderInfoTitle = [
    "订单总价",
    "订单编号",
    "联系人",
    "手机号",
    "收货地址",
    "订单状态",
    "配送方式",
    "是否含税",
    "下单时间",
    "支付时间",
    "发货时间",
    "留言信息",
];

const orderInfoKeys = {
    "订单总价":"finalPrice",
    "订单编号":"orderNum",
    "联系人":"delayName",
    "手机号":"delayPhone",
    "收货地址":"completeAddressInfo",
    "订单状态":"status",
    "配送方式":"deliverWay",
    "是否含税":"priceIncludeTax",
    "下单时间":"createTime",
    "支付时间":"payTime",
    "发货时间":"delayTime",
    "留言信息":"remark",
};

const baseUrl = "https://www.laizekeji.cn/laizeAdmin";
const placeholderImage = "https://www.laizekeji.cn/laizehomeImg/placeholder.png";

class LZHXOrderDetailPage extends React.Component {
    constructor(props) {
        super(props);

        this.state = { isLoading: false, orderDetail: {}, orderInfoList: {} };
    }

    componentDidMount() {
        let orderId = getQueryVariable("orderId");
        if (orderId != undefined && orderId != "") {
            this.requestOrderDetail(parseFloat(orderId));
        }
    }

    requestOrderDetail(orderId) {
        let orderInfo = {};

        const _this=this;
        this.setState({
            isLoading: true,
        });
        
        axios.post(baseUrl + '/hxcomponent/getOrderDetailById', qs.stringify({
            id: orderId,
        }))
            .then(function (res) {
                let address = res.data.address;
                let order = res.data.order;
                order.delayName = address.name || "无";
                order.delayPhone = address.phone || "无";
                order.completeAddressInfo = (address.area||"无") + (address.address||"无");
                order.finalPrice = "¥" + (order.finalPrice||"无");
                
                for (let key in orderInfoKeys) {
                    orderInfo[key] = order[orderInfoKeys[key]];
                }

                _this.setState({
                    isLoading: false,
                    orderDetail: res.data || {},
                    orderInfoList: orderInfo
                });
            })
            .catch(function (error){
                console.log(error);
                
                _this.setState({
                    isLoading: false,
                    orderDetail: {},
                    orderInfoList: orderInfo
                });
            });
    }

    render() {
        return (
            <div>
                <div style={{backgroundColor:"#ffffff",borderRadius:12,width:"100%"}}>
                    <br/>
                    <Title level={5} style={{width:100}} > 商品信息 </Title>
                    <List
                        itemLayout="horizontal"
                        size="small"
                        split={false}
                        dataSource={this.state.orderDetail.goodsDTOList}
                        renderItem={item => (
                            <List.Item key={item} >
                                <Space>
                                    <Image width={80} height={80} src={encodeURI(item.specificationImage.replace("http://47.92.85.113", "https://www.laizekeji.cn")||placeholderImage)} />
                                    <div>
                                        <div style={{textAlign:'left'}}> {item.goodsName} </div>
                                        <div style={{textAlign:'left', color:'#A9A9A9'}}> {item.specificationName} </div>
                                    </div>
                                    <div>
                                        <div> ¥{item.price} </div>
                                        <div style={{color:'#A9A9A9'}}> x{item.num} </div>
                                    </div>
                                </Space>
                            </List.Item>
                        )}
                    />
                </div>
                <br/>
                <div style={{backgroundColor:"#ffffff",borderRadius:12,width:"100%"}}>
                    <br/>
                    <Title level={5} style={{width:100}} > 订单信息 </Title>
                    <List
                        itemLayout="horizontal"
                        size="small"
                        dataSource={orderInfoTitle}
                        renderItem={item => (
                            <List.Item key={item} >
                                <div>
                                    <div> {item+": "+(this.state.orderInfoList[item]||"无")} </div>
                                </div>
                            </List.Item>
                        )}
                    />
                    <br/>
                </div>
            </div>
        );
    }
}

function getQueryVariable(variable)
{
       var query = window.location.search.substring(1);
       console.log(query);

       var vars = query.split("&");
       for (var i=0;i<vars.length;i++) {
               var pair = vars[i].split("=");
               if(pair[0] == variable){return pair[1];}
       }
       return(false);
}

export default LZHXOrderDetailPage;